var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full bg-white-pure flex flex-col items-center justify-center p-6"},[_c('v-alert',{attrs:{"dense":"","outlined":"","type":"error"}},[_vm._v(" "+_vm._s(_vm.alertText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }